<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="_pageSetting.primary"
    :secondary="_pageSetting.secondary"
    :customUpdateAction="customUpdateAction"
    :staticModelData="staticModelData"
    titleKey="name"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/role";
export default {
  data(){
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      staticModelData: (modelData, fields) => {
        model.scopeFields.forEach((scopeItem) => {
          if (fields[scopeItem].items.length) {
            fields[scopeItem].items.forEach((valueItem) => {
              let result = true;
              if (valueItem.value) {
                valueItem.value.forEach((item) => {
                  if (result) {
                    result = modelData.scopes.includes(item);
                  }
                });
                if (result) {
                  modelData[scopeItem] = [
                    ...(modelData[scopeItem] || []),
                    ...valueItem.value,
                  ];
                }
              }
            });
          }
        });
      },
      customUpdateAction: (modelData) => {
        modelData.scopes = [];
        model.scopeFields.forEach((scopeItem) => {
          if (modelData[scopeItem] !== null && modelData[scopeItem] !== undefined) {
            modelData.scopes.push(...modelData[scopeItem]);
          }
        });
        if (modelData.is_default !== undefined) {
          if (modelData.is_default === true) {
            modelData.is_default = 1
          } else if(modelData.is_default === false) {
            modelData.is_default = 0
          }
        }
        if (modelData.is_active !== undefined) {
          if (modelData.is_active === true) {
            modelData.is_active = 1
          } else if(modelData.is_active === false) {
            modelData.is_active = 0
          }
        }
      },
    }
  },
  computed: {
    _pageSetting() {
      return {
        primary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "角色資訊",
                fields: ["locales", "sequence"],
              },
              {
                title: "角色權限",
                fields: model.scopeFields,
              },
            ],
          },
        ],
        secondary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "客製角色",
                remark: "",
                fields: ["is_default", "factories"],
              },
            ],
          },
          {
            type: "infoCard",
            floors: [
              {
                title: "顯示設定",
                remark: "隱藏的內容將不會顯示於使用者前台介面",
                fields: ["is_active"],
              },
            ],
          },
        ],
      };
    },
  }
};
</script>